module.exports = "/_next/static/resources/life2-37aa4c9c25c5bf14832110ea5133399f.webp";